const config = {
    app_id: 867,
    app_name: 'Struggle',
    redirect_uri: 'https://strugglecasino.github.io',
    browser_uri: 'https://www.moneypot.com/',
    mp_api_uri: 'https://api.moneypot.com',
    chat_uri: '//socket.moneypot.com',
    debug: isRunningLocally(),
    force_https_redirect: !isRunningLocally(),
    house_edge: 0.05,
    chat_buffer_size: 20,
    bet_buffer_size: 25
};

(function() {
    let errString;
    if(config.house_edge <= 0.0) {
        errString = 'House edge must be greater than 0';
    } else if (config.house_edge >= 100) {
        errString = 'House edge must be lower than 100';
    }
    if(errString) {
        throw new Error(errString);
    }
    console.log('House edge:', (config.house_edge * 100).toString() + '%' );
})();



function isRunningLocally(){
    console.log('hihaa');
}

export default config;


// WEBPACK FOOTER //
// ./src/config.js